<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="读书会名称">
          <el-input placeholder="请输入读书会名称" v-model="formInline.search">

          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加读书会</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">

            <el-table-column prop="name" label="读书会名称"></el-table-column>
            <!-- <el-table-column prop="bannar" label="横幅"></el-table-column> -->

            <!-- <el-table-column prop="release_time" label="发布时间"></el-table-column> -->
            <el-table-column prop="start_date" label="开始时间"></el-table-column>
            <el-table-column prop="end_date" label="结束时间"></el-table-column>
            <el-table-column prop="place" label="活动地点"></el-table-column>
            <el-table-column prop="address" label="详细地址"></el-table-column>
            <!-- <el-table-column prop="intro" label="简介"></el-table-column>
            <el-table-column prop="ac_intro" label="活动介绍"></el-table-column> -->
            <el-table-column prop="speaker_name" label="主讲人姓名"></el-table-column>
            <!-- <el-table-column prop="speaker_intro" label="主讲人介绍"></el-table-column> -->
            <el-table-column prop="maxnum" label="最大参与人数"></el-table-column>
            <el-table-column prop="cost" label="费用设置"></el-table-column>
            <el-table-column prop="rule" label="带人规则"></el-table-column>
            <!-- <el-table-column prop="longitude" label="经度"></el-table-column>
            <el-table-column prop="latitude" label="纬度"></el-table-column> -->
            <!-- <el-table-column prop="tips" label="温馨提示"></el-table-column> -->


            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="135">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button v-if="scope.row.after_image" @click="auditClick(scope.row)" type="text" size="small">
                  {{ scope.row.audit == 1 ? '审核通过' : (scope.row.audit == 2 ? '审核不通过' : '审核') }}
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :reading_id="reading_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
    :close-on-click-modal="false"
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

    <el-dialog title="审核读书会" :visible.sync="auditDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <div style="padding: 20px 0;">
        <div style="text-align: center; margin-bottom: 20px;">
          <img v-if="currentAuditRow && currentAuditRow.after_image" :src="currentAuditRow.after_image" style="max-width: 100%; max-height: 300px;" />
        </div>
        <div style="text-align: center;">
          <p>请选择审核结果：</p>
          <el-button type="success" @click="confirmAudit(1)" style="margin-right: 20px;">通过</el-button>
          <el-button type="danger" @click="confirmAudit(2)">不通过</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        reading_id:"",
        dialogVisible:false,
        auditDialogVisible: false,
        currentAuditRow: null,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {


      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//读书会标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
     async getTableList() {
        let self = this;
        self.loading = true;
        const response = await AfuncApi.call({
          model: 'reading',
          action: 'index',
          page: this.curPage,
          list_rows: this.pageSize,
          ...this.formInline
        });
        
        if (response.code === 1 && response.data.list) {
           self.loading = false;
          self.tableData = response.data.list.data || [];
          self.totalDataNumber = response.data.list.total || 0;
        }

      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.reading_id = row.reading_id;
        this.open_edit = true
      },

      /*审核*/
      auditClick(row) {
        this.currentAuditRow = row;
        this.auditDialogVisible = true;
      },

      /*确认审核*/
      async confirmAudit(status) {
        const response = await AfuncApi.call({
          model: 'reading',
          action: 'audit',
          reading_id: this.currentAuditRow.reading_id,
          status: status,
        });
        
        if (response.code === 1) {
          this.$message.success(status === 1 ? '审核通过' : '审核不通过');
          this.auditDialogVisible = false;
          this.getTableList();
        } else {
          this.$message.error(response.msg || '审核失败');
        }
      },

      /*删除*/
     async deleteClick(row) {
         await this.$confirm('此操作将删除该读书会及其所有子读书会, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
      
            
            const response = await AfuncApi.call({
              model: 'reading',
              action: 'del',
              reading_id: row.reading_id,
            });
            
            if (response.code === 1) {
              this.$message.success('删除成功');
              this.getTableList();
            } else {
              this.$message.error(response.msg || '删除失败');
            }
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/reading/index/index.vue